import { Link } from "react-router-dom";

function ChooseIdentity() {
    return (
        <div className="items-center justify-center flex flex-col h-screen bg-[#2058a2] text-[#fff]">
            <button className="mb-5 bg-gradient-to-br from-[#7fdc16] to-[#4d860d] rounded-lg px-3 py-1 font-bold">我是病人</button>
        
            <Link to="./moderator_register">
                <button className="mb-5 bg-gradient-to-br from-[#59cebe] to-[#388379] rounded-lg px-3 py-1 font-bold"> 我是醫護人員</button>
            </Link>
        
            <Link to="../">
                <button className="mb-5 bg-gradient-to-br from-[#FFA500] to-[#a36b03] rounded-lg px-3 py-1 font-bold"> 返回 </button>
            </Link>
        </div>
    )
}

function ModeratorRegister() {
    return (
        <div className="justify-center flex flex-col h-screen bg-[#2058a2] text-[#fff]">
            <div id="inputs" className="my-5" style={{marginLeft: "30%"}}>
                <h1 className="text-4xl font-bold">註冊帳號</h1>
                <div className="my-5">
                    <label htmlFor="name" className="mx-5">　姓名　</label>
                    <input id="name" className="text-[#000] pl-1" type="text"></input>
                </div>
                <div className="my-5">
                    <label htmlFor="account" className="mx-5">電子信箱</label>
                    <input id="account" className="text-[#000] pl-1" type="text"></input>
                </div>
                <div className="my-5 ">
                    <label htmlFor="password" className="mx-5">　密碼　</label>
                    <input id="password" className="text-[#000] pl-1" type="password"></input>
                </div>
                <div className="my-5 ">
                    <label htmlFor="confirm_password" className="mx-5">確認密碼</label>
                    <input id="confirm_password" className="text-[#000] pl-1" type="password"></input>
                </div>
                <div className="my-5 ">
                    <label htmlFor="phone_number" className="mx-5">聯絡電話</label>
                    <input id="phone_number" className="text-[#000] pl-1" type="text"></input>
                </div>
                <div className="my-5 ">
                    <label htmlFor="workplace" className="mx-5">工作單位</label>
                    <input id="workplace" className="text-[#000] pl-1" type="text"></input>
                </div>
                <div className="my-5 ">
                    <label htmlFor="job_title" className="mx-5">職務名稱</label>
                    <input id="job_title" className="text-[#000] pl-1" type="text"></input>
                </div>
                
                <div className="my-5 ">
                <Link to="../">
                    <button id="login_button" className="mx-5 bg-gradient-to-br from-[#7fdc16] to-[#4d860d] rounded-lg px-3 py-1 font-bold" >返回</button>
                </Link>
                    <button id="register" className="bg-gradient-to-br from-[#59cebe] to-[#388379] rounded-lg px-3 py-1 font-bold">註冊</button>
                </div>
            </div>
        </div>
    )
}

export {ChooseIdentity, ModeratorRegister};